import './App.less';
import Run from './components/Run';
import { FC } from 'react';

const App: FC<{}> = (props) => {

    return (
        <>

            {/* Si Msal esta OK , se inicia la app */}
            <Run />

        </>
    );
}

export default App